/**
 * Brand constants. The product name, mark and palette live here and in
 * styles.css (:root tokens) only, so a rebrand is a two-file change.
 *
 * Palette and type follow trapmap.fun: near-black, one blue scale
 * (#0056f2 → #187eec → #50a1fa, deep #0f408c), Geist + Geist Mono.
 * Mark: the official TrapMap pixel portrait (public/brand/trapmap-*.png).
 */
export const BRAND = {
  name: 'TrapMap',
  domain: 'trapmap.fun',
  tagline: 'Know who you’re trading against.',
  x: 'https://x.com/trapmapdotfun',
  telegram: 'https://t.me/trapmapdotfun',
  /** Canvas colours mirror the CSS tokens (canvas can't read CSS vars cheaply). */
  canvasBg: '#060709',
  accent: '#3d8bff',
} as const;

export function BrandMark({ size = 26 }: { size?: number }) {
  const src = size > 48 ? '/brand/trapmap-192.png' : '/brand/trapmap-64.png';
  return <img className="brand-mark-img" src={src} width={size} height={size} alt="" aria-hidden="true" draggable={false} />;
}
